import { AppRoutes } from './navigations/routes';

function App() {
  return <AppRoutes />;
}

export default App;